import { z } from "zod";

export const fieldNumberSchema = z.preprocess((value) => {
    return (value !== null && value !== undefined) ? Number(value) : null
}, z.number().int().optional().nullable())
